import { useMemo } from 'react';
import useTheme from 'branding/theme';
const useInnerStyles = (isActive) => {
    const { borders, colors } = useTheme();
    return useMemo(() => ({
        ...borders.bottom,
        borderBottomColor: isActive ? colors.neutrals.transparent : colors.neutrals.textBeta
    }), [isActive, borders, colors]);
};
export default useInnerStyles;
//# sourceMappingURL=useInnerStyles.js.map